export const playVideo = () => {
    const modal = document.querySelector('.js-video-modal');
    if (!modal) return;

    const player = modal.querySelector('.js-video-player');
    const openBtns = document.querySelectorAll('.js-open-video-modal');
    const closeBtns = modal.querySelectorAll('.js-close-video-modal');

    const openModal = (src) => {
        player.src = src;
        modal.classList.add('video-modal--active');
        modal.setAttribute('aria-hidden', 'false');
        player.play();
    };

    const closeModal = () => {
        modal.classList.remove('video-modal--active');
        modal.setAttribute('aria-hidden', 'true');
        player.pause();
        player.currentTime = 0;
        player.src = '';
    };

    openBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const videoSrc = btn.dataset.videoSrc;
            if (videoSrc) openModal(videoSrc);
        });
    });

    closeBtns.forEach((btn) => {
        btn.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('video-modal--active')) {
            closeModal();
        }
    });
};